import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class QuestionAndAnswerModel extends BaseModel {
  @attr("string") question;
  @attr("string") answer;
  @attr("string") completedBy;
  @attr("string") completedAt;
}
